import React from "react";

function Loading() {
  return (
    <div>
      <div className="loadin-main-box-container">
        <div class="loader"></div>
      </div>
    </div>
  );
}

export default Loading;
